import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const store = new Vuex.Store({
  state: {
    count: 0,
    presetStates: {
      all_preset: {}
    },
    systemStates: {},
    persistentProps: {},
    modalHistory: {},
    notification: '',
    selectedModal: 'myOrganizations',
    fontSize: 16
  },
  mutations: {
    c2setPresetOrgExpanded (state, args) {
      var presetName = args[0]
      var key = args[1]
      var expanded = args[2]
      if (presetName in state.presetStates === false) {
        state.presetStates[presetName] = {}
      }
      state.presetStates[presetName][key] = expanded
    },
    c6setSysytemObjectExpanded (state, args) {
      var systemUid = args[0]
      var objectUid = args[1]
      var expanded = args[2]
      if (systemUid in state.systemStates === false) {
        state.systemStates[systemUid] = {}
      }
      if ('objectExpanded' in state.systemStates[systemUid] === false) {
        state.systemStates[systemUid]['objectExpanded'] = {}
      }
      state.systemStates[systemUid]['objectExpanded'][objectUid] = expanded
    },

    setPersistentProps (state, args) {
      var componentUid = args[0]
      var propsDict = args[1]
      if (componentUid in state.persistentProps === false) {
        state.persistentProps[componentUid] = {}
      }
      state.persistentProps[componentUid] = propsDict
    },

    increment (state) {
      state.count++
    },
    toggleDisplay (state) {
      state.showCreatePerson = !state.showCreatePerson
    },
    toggleCreateOpportunity (state) {
      state.showCreateOpportunity = !state.showCreateOpportunity
    },
    toggleCreateExpense (state) {
      state.showCreateExpense = !state.showCreateExpense
    },
    updateNotifications (state, x) {
      state.notification = x.slice(0)
    },
    updateFontSize (state, size) {
      state.fontSize = size
    }
  },
  plugins: [vuexLocal.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store.js